import { RevealWords } from './RevealWords';
import { Reveal } from './Reveal';

/**
 * Abertura de seção fofa: pílula com orelhinhas, título "quicando" e o texto
 * de apoio num balão de fala logo abaixo (em vez do layout título × parágrafo de agência).
 */
export const SectionHeading = ({
  kicker,
  icon: Icon,
  kickerClass = 'bg-pet-pink-soft text-pet-pink-ink',
  parts,
  note,
  align = 'left',
  titleClass = 'text-pet-ink',
  noteClass = 'bg-white text-pet-ink/80',
  children,
  className = '',
}) => {
  const center = align === 'center';
  return (
    <div className={`relative ${center ? 'flex flex-col items-center text-center mx-auto' : ''} max-w-4xl ${className}`}>
      <p className={`kicker kicker-ears mb-6 ${center ? '' : '-rotate-2'} ${kickerClass}`}>
        {Icon && <Icon className="w-4 h-4" />} {kicker}
      </p>
      <RevealWords
        className={`font-display font-medium text-[clamp(2.6rem,7.5vw,5.2rem)] leading-[1.05] ${titleClass}`}
        parts={parts}
      />
      {note && (
        <Reveal delay={0.25} y={20} rotate={center ? 0 : -2}>
          <p
            className={`speech ${center ? 'speech-center' : ''} mt-7 inline-block max-w-xl rounded-[26px] px-5 py-3.5 text-[17px] md:text-lg font-bold leading-relaxed shadow-[0_12px_30px_-18px_rgba(45,55,72,0.4)] ${noteClass}`}
          >
            {note}
          </p>
        </Reveal>
      )}
      {children}
    </div>
  );
};

export default SectionHeading;
